import { useState } from "react";
import { toast } from "sonner";
import { HeartHandshake, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errText } from "@/lib/api";
import { waNumber } from "@/lib/pdf";

const firstName = (n = "") => n.trim().split(/\s+/)[0] || "";

export const thankYouMessage = (i, school) => {
  const child = firstName(i.childName);
  return `Dear ${i.referralName},\n\n*Thank you for referring ${child}'s family to ${school}!* ` +
    `We're delighted to share that ${child} has joined us for ${i.grade}.\n\n` +
    `*Thanks & Regards,*\n${school}, Pune`;
};

export const ReferralThanks = ({ r, school, onSaved }) => {
  const [busy, setBusy] = useState(false);
  const i = r.inputs;
  const t = r.referral_thanked;
  const send = async () => {
    const num = waNumber(i.referralMobile);
    if (num.length < 10) return toast.error("Referral Mobile No. is missing or invalid");
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(thankYouMessage(i, school))}`, "_blank");
    setBusy(true);
    try { onSaved((await api.post(`/receipts/${r.id}/referral-thanked`)).data); toast.success("WhatsApp opened with the referrer's chat — tap Send"); }
    catch (e) { toast.error(errText(e)); }
    setBusy(false);
  };
  return (
    <Button size="sm" variant="outline" onClick={send} disabled={busy}
      className={t ? "border-emerald-200 text-emerald-800 hover:bg-emerald-50" : "border-[#25D366]/50 text-[#128C7E] hover:bg-[#25D366]/10"}
      title={t ? `Thanked by ${t.by} on ${new Date(t.at).toLocaleDateString("en-IN")}` : `Thank ${i.referralName} on WhatsApp`}
      data-testid="referral-thank-btn">
      {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <HeartHandshake className="mr-1.5 h-3.5 w-3.5" />}
      {t ? "Referrer thanked ✓ · send again" : "Thank referrer on WhatsApp"}
    </Button>
  );
};
